import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import styled from "styled-components";
import SidebarItem, { ISidebar } from "./item";
import { device } from "components/styles";
import { getUserInfo } from "utils/utility";
import { UserType } from "models/Auth";

const menus: ISidebar[] = [
  { name: "마이페이지", path: "/mypage" },
  { name: "정보수정", path: "/mypage/edit" },
  // { name: "전문가정보", path: "/mypage/expert" },
  { name: "나의 활동", path: "/mypage/activity" },
  { name: "IBS", path: "/mypage/ibs" },
  { name: "멤버십/열람권 관리", path: "/mypage/membership" },
  // { name: "매칭 관리", path: "/mypage/matching" },
  { name: "이용약관 및 정책", path: "/mypage/term" },
  { name: "고객센터", path: "/mypage/service-center" },
];
const AppSidebar = () => {
  const userInfo = getUserInfo() as { userType?: UserType };
  console.log("userInfo", userInfo);
  return (
    <Slide>
      <Box sx={{ overflow: "auto" }}>
        <List>
          {menus.map((menu) => {
            if (
              menu.name === "IBS" &&
              !(
                userInfo?.userType === "DOCTOR" ||
                userInfo?.userType === "HOSPITAL"
              )
            ) {
              return null;
            }
            return (
              <SidebarItem key={menu.path} name={menu.name} path={menu.path} />
            );
          })}
        </List>
      </Box>
    </Slide>
  );
};

export const Slide = styled.div`
  height: calc(100vh - 7rem);
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8ecf2;
  padding: 3.2rem 2.4rem;

  @media all and (${device.mobile}) {
    display: none;
  }
`;

export default React.memo(AppSidebar);
